import FaqModal from './FaqModal.vue'

export default FaqModal
